<template>
  <g>
    <path
      d="M6.82 13.0002H11V11.0002H6.82C6.4 9.84024 5.3 9.00024 4 9.00024C2.34 9.00024 1 10.3402 1 12.0002C1 13.6602 2.34 15.0002 4 15.0002C5.3 15.0002 6.4 14.1602 6.82 13.0002ZM4 13.0002C3.45 13.0002 3 12.5502 3 12.0002C3 11.4502 3.45 11.0002 4 11.0002C4.55 11.0002 5 11.4502 5 12.0002C5 12.5502 4.55 13.0002 4 13.0002Z"
    />
    <path
      d="M22.47 12.4002C22.74 12.2002 22.74 11.8002 22.47 11.6002L19 9.0002V11.0002H14.95C14.48 6.3102 10.79 2.5802 6.12 2.0602C5.52 2.0002 5 2.4602 5 3.0602C5 3.5602 5.37 3.9902 5.87 4.0502C9.88 4.4802 13 7.8702 13 12.0002C13 16.1302 9.88 19.5202 5.87 19.9502C5.37 20.0102 5 20.4402 5 20.9402C5 21.5402 5.52 22.0102 6.11 21.9402C10.78 21.4202 14.48 17.6902 14.94 13.0002H19V15.0002L22.47 12.4002Z"
    />
  </g>
</template>
